import React from 'react'

const Footer = () => {
  return (
    <footer className='bg-primary-darker py-[24px] text-white text-sm text-center'>2024 &copy; S Bhasin & Associates</footer>
  )
}

export default Footer